import { LocalDate } from '@js-joda/core';

import { Range } from '@dreryk/watermelon';

import { DEFAULT_INSURANCE_TYPE } from '../common/common.constants';
import { getTodayDate } from '../common/common.utils';

import { MedicalLeaveFormBean } from './medicalLeave.types';

export const getMedicalLeaveFormInitialValues = (): MedicalLeaveFormBean => ({
   insuranceType: DEFAULT_INSURANCE_TYPE,
   canWalk: true,
   codeA: false,
   codeB: false,
   codeC: false,
   codeD: false,
   codeE: false,
   diagnosis: null,
   reason: null,
   payers: [],
   leaveAfterTerminationOfEmployment: {},
   leaveDateRange: Range.closed<LocalDate>(getTodayDate(), getTodayDate()),
   address: null,
});
